<template>
  <div>
    <SafieDialog
      :show-close="false"
      :title="t('global.ERROR_MODAL_TITLE')"
      :visible="visible"
    >
      <template #default>
        <div class="main" v-html="message"></div>
      </template>
      <template #footer>
        <div class="footer">
          <SafieButton type="cancel" @click="closeDialog">{{
            t("global.CLOSE_BTN")
          }}</SafieButton>
        </div>
      </template>
    </SafieDialog>
  </div>
</template>
<script lang="ts" setup>
import { useStore } from "@/store";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import SafieButton from "./SafieButton.vue";
import SafieDialog from "./SafieDialog.vue";

const { t } = useI18n();
const store = useStore();
const visible = computed(() => store.state.errorModal.visible);
const message = computed(() => store.state.errorModal.message);
const closeDialog = () => {
  store.commit("closeErrorModal");
};
</script>
<style lang="scss" scoped>
.main {
  margin: 0 40px 32px;
  font-weight: 400;
  font-size: 14px;
  line-height: 180%;
  color: var(--safie-active-text);
}
.footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  height: 72px;
  margin-right: 40px;
}
@media screen and (max-width: 572px) {
  .main {
    margin: 0 16px 32px;
  }
  .footer {
    margin-right: 16px;
  }
}
</style>
